export const DEFAULT_DIALOG_TITLE = "Results";

export const COLUMNS_WEIGHT: { [key: string]: number } = {
  name: 100000,
  operation: 100001,
  userPrincipalName: 1000,
  password: 0,
  status: -1,
  error: -1000,
  location: -10000,
};
